import BaseModel from './BaseModel'
import { INSERT_PLAN_CATEGORIES } from '../redux/actions/planCategories'
import { many } from 'redux-orm'
import camelize from 'camelize'

class PlanCategory extends BaseModel {
  static reducer (action, PlanCategory, session) {
    switch (action.type) {
      case INSERT_PLAN_CATEGORIES:
        action.categories.forEach(category => {
          const camelizedCategoryObj = camelize(category)
          const planCategory = PlanCategory.create(camelizedCategoryObj)
          planCategory.planSubcategories.clear()
          const subcategories = category.subcategories || []
          subcategories.forEach(subcategory => {
            planCategory.planSubcategories.add(subcategory.slug)
          })

          if (action.includeFeaturedProducts) {
            const featuredProducts = camelizedCategoryObj.featuredProducts
            planCategory.products.clear()
            featuredProducts.forEach(product => {
              planCategory.products.add(product.id)
              session.Product.upsert(camelize(product))
            })
          }
        })
        break
    }
  }
}

PlanCategory.modelName = 'PlanCategory'
PlanCategory.fields = {
  planSubcategories: many('PlanSubcategory', 'parentCategories'),
  products: many('Product', 'planCategory')
}
PlanCategory.options = {
  idAttribute: 'slug'
}

export default PlanCategory
